import { useEffect, useState } from "react";
import { Volume2, VolumeX, Loader2 } from "lucide-react";
import { speak, stopSpeaking, speechState, onSpeechState, canSpeak } from "@/lib/speech";
import { useAuth } from "@/context/AuthContext";

// Shows only for Explorers with the read-aloud accommodation (and Guides, for previewing).
export function useReadAloud() {
  const { user } = useAuth();
  return !!(user && canSpeak() && (user.read_aloud || user.role === "guide"));
}

export function SpeakButton({ text, testid, label, className = "", size = "sm" }) {
  const [st, setSt] = useState(speechState());
  const [mine, setMine] = useState(false);
  useEffect(() => onSpeechState((s) => { setSt(s); if (s === "idle") setMine(false); }), []);
  const busy = mine && st === "loading";
  const playing = mine && st === "speaking";
  const icon = size === "sm" ? "w-3.5 h-3.5" : "w-4 h-4";
  const onClick = (e) => {
    e.stopPropagation();
    if (playing || busy) { stopSpeaking(); return; }
    speak(text); // resets global state to idle synchronously first, so mine=true below survives React batching
    setMine(true);
  };
  return (
    <button type="button" data-testid={testid} onClick={onClick} title={playing ? "Stop reading" : busy ? "Loading… click to cancel" : "Read aloud"}
      className={`inline-flex items-center gap-1.5 shrink-0 rounded-full border transition-colors ${label ? "px-3 py-1.5 text-xs" : "p-1.5"} ${playing ? "border-[#E11D48]/60 text-[#E11D48]" : "border-[#22D3EE]/50 text-[#22D3EE] hover:bg-[#22D3EE]/10"} ${className}`}>
      {busy ? <Loader2 className={`${icon} animate-spin`} /> : playing ? <VolumeX className={icon} /> : <Volume2 className={icon} />}
      {label && <span>{playing ? "Stop" : label}</span>}
    </button>
  );
}
